import { ITableRowData } from '../components/table'
import { rateTypes } from '../lib/rates'
import { capitalise, formatDollars } from './otherUtils'

export const getLevyTableData = (
  parcelsSelected: any,
  parcelAggregates: any,
  areaData: any,
  rates: any,
  parcelSpi?: string,
  parcelData?: any,
  detailed: boolean = false,
  filterZeros: boolean = false,
  smallMobile: boolean = false
) => {
  const getProperty = (property: string) => {
    if (parcelSpi) return parcelData[parcelSpi][property]
    if (parcelsSelected.length) {
      return parcelAggregates['sum' + capitalise(property)]
    }
    return areaData[property]
  }

  let data = [
    ['Native vegetation', `${getProperty('nvArea')} ha`],
    ['Scattered trees', `${getProperty('scatteredTreesCount')} trees`],
    ['Golden Sun Moth', `${getProperty('gsmArea')} ha`],
    ['Growling Grass Frog', `${getProperty('ggfArea')} ha`],
    ['Matted Flax-lily', `${getProperty('mflArea')} ha`],
    ['Southern Brown Bandicoot', `${getProperty('sbbArea')} ha`],
    ['Spiny Rice-flower', `${getProperty('srfArea')} ha`]
  ]
  if (detailed) {
    if (!smallMobile) {
      rateTypes.forEach((x, index) => {
        data[index] = data[index].concat([formatDollars(rates[x])])
      })
    }
    rateTypes.forEach((x, index) => {
      data[index] = data[index].concat([formatDollars(getProperty(x.replace(/Count|Area/g, 'Amount')))])
    })
  }
  if (filterZeros) {
    data = data.filter(x => x[3] !== '$0')
  }
  return data.map(x => {
    return {
      rowData: x,
      warningData: []
    }
  })
}

export const getConservationAreaTableData = (
  parcelsSelected: any,
  parcelAggregates: any,
  areaData: any,
  parcelSpi?: string,
  parcelData?: any
): ITableRowData[] => {
  let source

  if (parcelsSelected.length > 0 && !parcelSpi) {
    source = parcelAggregates
  } else if (parcelsSelected.length > 0 && parcelSpi) {
    source = parcelData[parcelSpi]
  } else {
    source = areaData
  }
  return source.conservationAreas.map((x: any) => {
    return { rowData: [x[0], x[1], `${x[2].toFixed(3)} ha`], warningData: [] }
  })
}

export const getTotalEstimate = (parcelsSelected: any, parcelAggregates: any, areaData: any) => {
  let sum: number
  if (parcelsSelected.length) {
    sum =
      parcelAggregates.sumGgfAmount +
      parcelAggregates.sumGsmAmount +
      parcelAggregates.sumMflAmount +
      parcelAggregates.sumNvAmount +
      parcelAggregates.sumSbbAmount +
      parcelAggregates.sumScatteredTreesAmount +
      parcelAggregates.sumSrfAmount
  } else {
    sum =
      areaData.ggfAmount +
      areaData.gsmAmount +
      areaData.mflAmount +
      areaData.nvAmount +
      areaData.sbbAmount +
      areaData.scatteredTreesAmount +
      areaData.srfAmount
  }

  return formatDollars(sum)
}

export const getParcelEstimate = (parcelSpi: string, parcelData: any) => {
  const sum: number =
    parcelData[parcelSpi].ggfAmount +
    parcelData[parcelSpi].gsmAmount +
    parcelData[parcelSpi].mflAmount +
    parcelData[parcelSpi].nvAmount +
    parcelData[parcelSpi].sbbAmount +
    parcelData[parcelSpi].scatteredTreesAmount +
    parcelData[parcelSpi].srfAmount

  return formatDollars(sum)
}
